module.exports = __webpack_public_path__ + "img/icon_beian.d0289dc0.png";